import { ApiAddress } from '@/services/apis'
import request from '@/services/request'
import { ID } from '../common.model'
import { Comment, Task } from './task.model'

export function getProjectTasks(projectType: string, projectId: ID): Promise<[Task.Info[], any]> {
  return request.get(ApiAddress.PROJECT_TASKS, { params: { projectType, projectId } })
}

export function getProjectClosedTasks(projectType: string, projectId: ID): Promise<Task.Info[]> {
  return request.get(ApiAddress.PROJECT_CLOSED_TASKS, { params: { projectType, projectId } })
}

export function createProjectTask(projectType: string, projectId: ID, data: any) {
  return request.post(ApiAddress.PROJECT_TASKS, data, { params: { projectType, projectId } })
}

export function getTask(id: ID): Promise<Task.Info> {
  return request.get(ApiAddress.TASK, { params: { id } })
}

export function getPreTasks(id: ID): Promise<Task.Info[]> {
  return request.get(ApiAddress.PRE_TASKS, { params: { id } })
}

export function linkPreTasks(id: ID, predecessorTasks) {
  return request.post(ApiAddress.LINK_PRE_TASKS, { predecessorTasks }, { params: { id } })
}

export function unlinkPreTasks(id: ID, predecessorTasks) {
  return request.post(ApiAddress.UNLINK_PRE_TASKS, { predecessorTasks }, { params: { id } })
}

export function getSubTasks(id: ID): Promise<Task.Info[]> {
  return request.get(ApiAddress.SUB_TASKS, { params: { id } })
}

export function createSubTask(id: ID, body: any) {
  return request.post(ApiAddress.SUB_TASKS, body, { params: { id } })
}

export function editTask(id: ID, body: any): Promise<Task.Info> {
  return request.put(ApiAddress.TASK, body, { params: { id } })
}

export function updateTaskOrder(id: ID, body: any) {
  return request.put(ApiAddress.TASK_ORDER, body, { params: { id } })
}

export function editTaskDate(id: ID, body: any): Promise<Task.Info> {
  return request.put(ApiAddress.TASK_DATE, body, { params: { id } })
}

export function deleteTask(id: ID) {
  return request.delete(ApiAddress.TASK, { params: { id } })
}

export function getTaskComments(id: ID): Promise<Comment.Info[]> {
  return request.get(ApiAddress.TASK_COMMENTS, { params: { id } })
}

export function createTaskComment(id: ID, body: any) {
  return request.post(ApiAddress.TASK_COMMENTS, body, { params: { id } })
}

export function editComment(id: ID, body: any) {
  return request.put(ApiAddress.COMMENT, body, { params: { id } })
}

export function deleteComment(id: ID) {
  return request.delete(ApiAddress.COMMENT, { params: { id } })
}

export const taskStatusEnum = {
  IN_PROGRESS: 'In-progress',
  CLOSED: 'Closed',
  OPEN: 'Open',
  ON_HOLD: 'On-hold'
}

export const taskPriorityEnum = {
  1: 'Highest',
  2: 'High',
  3: 'Normal',
  4: 'Low'
}

export const workingUnitEnum = {
  1: 'Hours',
  2: 'Day',
  3: 'Week',
  4: 'Month'
}

export const currencyUnitEnum = {
  1: 'USD'
}

export const statusOptions = Object.keys(taskStatusEnum).map((key) => ({
  value: key,
  label: taskStatusEnum[key]
}))

export const priorityOptions = Object.keys(taskPriorityEnum).map((key) => ({
  value: Number(key),
  label: taskPriorityEnum[key]
}))

export const workingUnitOptions = Object.keys(workingUnitEnum).map((key) => ({
  value: Number(key),
  label: workingUnitEnum[key]
}))

export const currencyUnitOptions = Object.keys(currencyUnitEnum).map((key) => ({
  value: Number(key),
  label: currencyUnitEnum[key]
}))
